import { Permission } from '@cims-online/shared'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreDsTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { DSType, useTypesTableContext } from '../../../../TypesTableContext'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'

export function useRestore(): RestoreRowActionOptions<DSType> {
  const { refetch } = useTypesTableContext()
  const [restore] = useRestoreDsTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreDSType: {
        type: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittalType,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
